import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../../context/auth';
import { Wrapper } from './VerificationBanner.styles';

export function VerificationBanner() {
    const [emailSent, setEmailSent] = useState(false);
    const { authToken } = useAuth();
    const sendVerificationEmail = () => {
        axios.post('/api/v2/accounts/verification/create-new-link/', {}, {headers: { DTOKEN: `${authToken}`}}).then(() => {
            setEmailSent(true);
        })
    }
    return (
        <Wrapper>
            <div>
                <p>You are yet to confirm your email address!</p>
                <button onClick={sendVerificationEmail}>{emailSent ? 'Email sent' : 'Resend confirmation email'}</button>
            </div>
        </Wrapper>
    )
}
